// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router";
// import SectionHero from "../sections/SectionHero";
// import { SubCategoryGet } from "../../api/orgService";
// import useApi from "../../api/useApi";
// import { toast } from "react-toastify";

// const workstreamsdata = {health:[
//   {
//     name: "Maternal Health ",
//     desc: "Fountain Africa’s goal for Maternal, Newborn, Child and Adolescent Health programming is to reduce maternal and infant/child mortality and increase utilization of user-friendly reproductive health services. The aim is to ensure that all members of the community survive and thrive.",
//     image_introduction: "https://www.fountainafrica.org/wp-content/uploads/2020/01/2-1536x839.jpg",
//     description:"Newborn mortality is a serious health problem in Bungoma County, Kenya, with the rate at 33 deaths per 1000 live births against a national average of 22 per 1000 live births (KDHS 2014).  Approximately 50% of mothers in Bungoma County deliver at home. This puts babies, at risk of infections and death. Poor neonatal infrastructure as well as negative cultural barriers complicates the matter. The collaborative newborn support project implemented by Fountain Africa Trust in collaboration with Mount Kenya University and the County Ministry of Health in Bungoma was designed to address this gap."
//   },
//   {
//     name: "New Born Health",
//     desc: "Fountain Africa’s goal for Maternal, Newborn, Child and Adolescent Health programming is to reduce maternal and infant/child mortality and increase utilization of user-friendly reproductive health services. The aim is to ensure that all members of the community survive and thrive.",
//     image_introduction: "http://www.fountainafrica.org/wp-content/uploads/2025/10/IMG-20210823-WA0059.jpg",
//     description:"Newborn mortality is a serious health problem in Bungoma County, Kenya, with the rate at 33 deaths per 1000 live births against a national average of 22 per 1000 live births (KDHS 2014).  Approximately 50% of mothers in Bungoma County deliver at home. This puts babies, at risk of infections and death. Poor neonatal infrastructure as well as negative cultural barriers complicates the matter. The collaborative newborn support project implemented by Fountain Africa Trust in collaboration with Mount Kenya University and the County Ministry of Health in Bungoma was designed to address this gap.",
//     tag:"Every Newborn Deserves a Fighting Chance: Building Hope Through Better Healthcare"
//   },
//   {
//     name: "Community Midwifery",
//     desc: "Fountain Africa Trust supports a network of Private Community Midwives in Kenya who provide safe delivery services within the communities where they live. The aim the community midwifery approach is to improve access to and utilization of skilled attendance at birth for pregnant women especially in rural and marginalized communitie",
//     image_introduction: "https://fountainafrica.org/wp-content/uploads/2020/01/image.png",
//     description:"The Birth Wise Network is an affiliate member of the National Midwives Association of Kenya. Midwives in the network offer maternal health services including Antenatal Care, Safe Vaginal Delivery, Postnatal Care, Cervical Cancer Screening, STI treatment, Family Planning, Growth Monitoring and Immunization among other services at an affordable fee. Clients pay for services in cash and in kind. Fountain Africa has over the years assisted and participated in setting standards for Birth Wise Network members, enrolling new members, providing supportive supervision to members, undertaking capacity building in Family Planning methods and business skills as well as adolescent-friendly sexual and reproductive health services, safe delivery, and care of the newborn to the Network membership."
//   },
//   {
//     name: "Gender Base Violence",
//     desc: "We support communities and partners to secure recognition, representation, and influence in the decisions that affect their seas – locally, nationally, and globally.",
//     image_introduction: "https://www.fountainafrica.org/wp-content/uploads/2020/01/3.jpg",
//   },
// ], "humanitarian-response":[{
//   name: "Quality Improvement",
//   desc: "Our shared platform enables communities to generate, access and use real-time data to inform decisions, strengthen advocacy, and measure outcomes of fisheries and habitat management.",
//   image_introduction: "https://www.fountainafrica.org/wp-content/uploads/2020/01/2-1536x839.jpg",
// },
// {name:"Call Centre Services",
//   desc:"Fountain Africa Trust runs a Call Centre through which expectant mothers identified through Community Health Volunteers (CHVs) and ANC clinics are followed. The follow-up is meant to ensure that the mothers deliver in health facilities or with the assistance of trained and skilled health providers and that the health of their newborns is monitored over time.",
//   image_introduction:"https://www.shutterstock.com/image-photo/call-center-black-woman-smile-260nw-2289080225.jpg",
//   description:"The Call Centre offers personalized consultations to pregnant and new mothers to ensure the well-being of both the mother and the baby are taken care of. Mothers and babies who are found to have any form of complications are referred to the nearest health facility for appropriate care",
//  tag:"Bridging Distance, Delivering Care: Mobile Health Support for Mothers & Newborns"
// },
// {name:"Support to Persons Living with Disabilities",desc:"People with disability are among the most marginalized in many societies including in Kenya. Although the Kenyan Constitution states that all citizens be provided with equal access to services in the country, people with disability have difficulties in enjoying their constitutional rights. Disability constitute 10% of the population of Kenya. There are different types of disabilities ranging from physical to hearing impairment, blindness and mental disability, all of which require different specialization to facilitate their movement, and activities in life. Fountain Africa Trust initiated a project in Western Kenya that aims at enhancing the ability of people living with disability to earn a dignified living",
//   image_introduction:"",
//   description:"Fountain Africa Trust initiated a project in Western Kenya that aims at enhancing the ability of people living with disability to earn a dignified living Fountain Africa Trust supports children with Autism Spectrum Disorder through the Austin Project"
// }
// ],
// "drug-substance-abuse":[]};

  

// export default function WhatWeDo() {

//   const location = useLocation()
//   const [workstreams,setWorkStream]=useState([])
//   const [currentCategoryAlias,setCurrentCategoryAlias] = useState("")
//   const navigate = useNavigate()


//   // get area of work categories
  
//     const { request: getAllSubCategories, data:subCategoryData, error:subCategoryError} = useApi(SubCategoryGet);
      
//       // useEffect(() => {
//       //   getAllSubCategories();
//       //        // eslint-disable-next-line
//       //   }, []);
        
//         useEffect(()=>{
//           if (subCategoryData?.status===200) {
//             // setAreas(subCategoryData?.data);
//           }
//         // eslint-disable-next-line
//         },[subCategoryData])

//         useEffect(()=>{
//           if(currentCategoryAlias){
//             setWorkStream(workstreamsdata[currentCategoryAlias])
//           }
//         },[currentCategoryAlias,location])

        
//         useEffect(()=>{
//           if(location?.state?.category){
//             setCurrentCategoryAlias(location?.state?.category?.subcategory_alias)
//           }else if(location?.state?.refresh==="category"){
//             getAllSubCategories();
//           }else if(location?.pathname?.includes("what-we-do")){
//               console.log(location?.pathname.split("/")[2])
//               setCurrentCategoryAlias(location?.pathname.split("/")[2])
//               // getAllSubCategories(location?.pathname.split("/")[2])
//             }
        
          
//         },[location])

      
//         useEffect(()=>{
//             if(subCategoryError){
//                 toast.error(`${JSON.stringify(subCategoryError?.response?.data,null,2)}`,{position: "top-center"});
//           }
//         },[subCategoryError])

//   // End get area of work sub categories

//   // useEffect(()=>{
//   //   if(location?.state?.category){
//   //     setCurrentCategoryAlias(location?.state?.category?.subcategory_alias)
//   //   }
//   // },[location?.state])

  

//   return (
//     <div className="bg-gray-50 text-gray-800">

//     <SectionHero
//       title={`Our work in ${currentCategoryAlias}`}
//       subtitle="We create lasting impact by working hand in hand with local communities to build sustainable solutions for the oceans, the people, and the planet."
//       imageUrl="http://www.fountainafrica.org/wp-content/uploads/2025/10/IMG-20210823-WA0058.jpg"
//       overlayColor="rgba(15, 23, 42, 0.55)" // navy tint matching your theme
//     />

//       {/* Workstreams Section */}
//       <section className="py-16 px-6 max-w-7xl mx-auto">
//         {/* <h2 className="text-3xl font-bold text-center mb-12">
//           Our work
//         </h2> */}
//         <div className="grid gap-8 md:grid-cols-2">
//           {workstreams?.map((item, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition"
//               onClick={(e)=>{
//                 e.preventDefault()
//                 navigate(`/what-we-do-in/${item.name}`,{state:{image_introduction:item.image_introduction,name:item.name, description:item.desc,category:currentCategoryAlias,description:item.description,tag:item?.tag,isProjectView:false}})
//               }}
//             >
//               <img
//                 src={item.image_introduction}
//                 alt={item.name}
//                 className="h-56 w-full object-cover"
//               />
//               <div className="p-6">
//                 <h3 className="text-xl font-semibold text-blue-700 mb-3">
//                   {item.name}
//                 </h3>
//                 <p className="text-gray-600 leading-relaxed">{item.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import SectionHero from "../sections/SectionHero";
import { CategoryGetDetail, SubCategoryByCategoryGetDetail, SubCategoryGet } from "../../api/orgService";
import useApi from "../../api/useApi";
import { toast } from "react-toastify";

const workstreamsdata = {
  health: [
    {
      name: "Maternal Health",
      desc: "Fountain Africa’s goal for Maternal, Newborn, Child and Adolescent Health programming is to reduce maternal and infant/child mortality and increase utilization of user-friendly reproductive health services. The aim is to ensure that all members of the community survive and thrive.",
      image_introduction:
        "https://file.fountainafrica.org/wp-content/uploads/2020/01/2-1536x839.jpg",
      description:
        "Newborn mortality is a serious health problem in Bungoma County, Kenya, with the rate at 33 deaths per 1000 live births against a national average of 22 per 1000 live births (KDHS 2014). Approximately 50% of mothers in Bungoma County deliver at home. This puts babies at risk of infections and death.",
    },
    {
      name: "New Born Health",
      desc: "Fountain Africa’s goal for Maternal, Newborn, Child and Adolescent Health programming is to reduce maternal and infant/child mortality and increase utilization of user-friendly reproductive health services.",
      image_introduction:
        "http://file.fountainafrica.org/wp-content/uploads/2025/10/IMG-20210823-WA0059.jpg",
      description:
        "Newborn mortality is a serious health problem in Bungoma County, Kenya, with the rate at 33 deaths per 1000 live births against a national average of 22 per 1000 live births (KDHS 2014). Approximately 50% of mothers deliver at home.",
      tag: "Every Newborn Deserves a Fighting Chance",
    },
  ],
  "humanitarian-response": [
    {
      name: "Quality Improvement",
      desc: "Our shared platform enables communities to generate, access and use real-time data to inform decisions, strengthen advocacy, and measure outcomes.",
      image_introduction:
        "https://file.fountainafrica.org/wp-content/uploads/2020/01/2-1536x839.jpg",
    },
  ],
  "drug-substance-abuse": [],
};

export default function WhatWeDo() {
  const location = useLocation();
  const [workstreams, setWorkStream] = useState([]);
  const [currentCategoryAlias, setCurrentCategoryAlias] = useState("");
  const navigate = useNavigate();
  const { request: getAllSubCategories, data: subCategoryData, error: subCategoryError } = useApi(SubCategoryGet);
  const { request: getAllSubCategoriesByCategory, data: subCategoryByCategoryData, error: subCategoryByCategoryError } = useApi(SubCategoryByCategoryGetDetail);
  
  // useEffect(() => {
  //   if (currentCategoryAlias) {
  //     setWorkStream(workstreamsdata[currentCategoryAlias]);
  //   }
  // }, [currentCategoryAlias, location]);

  useEffect(()=>{
    if(location?.state?.id){
      getAllSubCategoriesByCategory(location?.state?.id)
    }
  },[location])

  useEffect(()=>{
    if(location?.state?.previewSubCategory){
      // getAllSubCategoriesByCategory(location?.state?.id)
      setWorkStream((prev)=>[...prev,location?.state?.previewSubCategory])
    }
  },[location?.state?.previewSubCategory,subCategoryByCategoryData])
  
  useEffect(()=>{
    // console.log("here: ",location?.state)
    if(subCategoryByCategoryData?.data?.length>0){
      // console.log("here: ",subCategoryByCategoryData?.data)
      setWorkStream(subCategoryByCategoryData?.data)
    }
  },[subCategoryByCategoryData,])

  // useEffect(() => {
  //   if (location?.state?.category) {
  //     setCurrentCategoryAlias(location?.state?.category?.subcategory_alias);
  //   } else if (location?.pathname?.includes("what-we-do")) {
  //     setCurrentCategoryAlias(location?.pathname.split("/")[2]);
  //   }
  // }, [location]);

  useEffect(() => {
    if (subCategoryError) {
      toast.error(
        `${JSON.stringify(subCategoryError?.response?.data, null, 2)}`,
        { position: "top-center" }
      );
    }
  }, [subCategoryError]);

  return (
    <div className="whatwedo-container">
      <SectionHero
        title={`Our work in ${location?.state?.category_alias}`}
        subtitle="We create lasting impact by working hand in hand with local communities to build sustainable solutions for people and the planet."
        imageUrl="http://file.fountainafrica.org/wp-content/uploads/2025/10/IMG-20210823-WA0058.jpg"
        overlayColor="rgba(15, 23, 42, 0.55)"
      />

      <section className="whatwedo-section">
        <div className="whatwedo-grid">
          {workstreams?.map((item, index) => (
            <div
              key={index}
              className="whatwedo-card"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/what-we-do-in/${item.name}`, {
                  state: {
                    image_introduction: item.image_introduction,
                    name: item.name,
                    description: item.description,
                    category: currentCategoryAlias,
                    tag: item?.tag,
                    isProjectView: false,
                    id: item.id,
                  },
                });
              }}
            >
              <img
                src={item.image_introduction}
                alt={item.name}
                className="whatwedo-card-image"
              />
              <div className="whatwedo-card-body">
                <h3 className="whatwedo-card-title">{item.name}</h3>
                <p className="whatwedo-card-text">{item.description.slice(0,500)}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
